import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  KindInterface,
  selectKindById,
  setEditId,
  setEditError
} from "../../../store/community/kindsSlice";
import {
  updateKind,
  fetchKind
} from "../../../actions/community/kindsActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any  = useAppSelector(state => state.community.kinds.editId);
  const kind     = useAppSelector((state) => selectKindById(state, id));
  const error    = useAppSelector(state => state.community.kinds.editError);

  useEffect(() => {
    if (id) {
      dispatch(fetchKind(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: KindInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: object) {
    const rules         = {};
    const formData: any = objToFormData(data, rules);
    const resultAction  = await dispatch(updateKind({ id, data: formData }));

    if (updateKind.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-kind'>
        <h6 className="v-content-label">Edit Kind</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        {
          kind &&
            <Form
              params={kind}
              onFinish={onFinish}
            />
        }
      </div>
    </DrawerRight>
  )
}

export default Edit;
